import React from 'react';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { MDBContainer, MDBTable, MDBTableBody, MDBTableHead, MDBDataTable } from 'mdbreact';
import * as misConstantes from '../../../js/constantes.js';
import InicioBreadcrumbs from '../../../pages/template/breadcrumbs/InicioBreadcrumbs.js'

import {
	Switch,
	Route,
	BrowserRouter,
	Link,
	useLocation,
	useParams
} from "react-router-dom";

import axios from "axios";



class ModificacionesOrdenesCompra extends React.Component {
	constructor(props) {
	    super(props);

		
 		var columnas = [ 
								
								{ field: "numeroOrdenCompra", label: "# OC", attributes: {'width':'20%'} },
								{ field: "entidad", label: "Entidad", attributes: {'width':'40%'} },
								{ field: "fechaModificacion", label: "Fecha", attributes: {'width':'30%'} },
								{ field:"botones", label: "", sort: 'asc', width :  "10%" , attributes: { 'width': '10%', 'align': 'center' } }
 
 						];
	    this.state = {  
	    						datos: {columns: columnas, rows:[]}, columnas: columnas
						};
	}
	componentDidMount() {
		this.cargarCotizacions();
	}
	

	
	
	render(){
		 
	
		 return (
			<>
				<div class="menu" style={{backgroundColor:  "#dbe7fc", width: "100%", padding: "10px", fontSize: "12px" }}>
					<div class="container">
						<InicioBreadcrumbs></InicioBreadcrumbs> / Modificaciones ordenes compra
					</div>
				</div>
				<div class="container" style={{minHeight: '550px', paddingTop: "30px"}}>
					<div class = 'subitulosPaginaNotificaciones'>
						<b>Modificaciones orden compra</b>
					</div><br/>
				
					
					
					<MDBDataTable striped bordered  small data={ this.state.datos } hover entriesOptions={[5, 10, 15, 25]} entries={15} pagesAmount={4} condensed/>
					<br/><br/>
				
				
				{ /**
				// ------------------------------------------------------------------------------------------------------
				// Cotizacion
				// ------------------------------------------------------------------------------------------------------
				 */}
				
					 
				</div>
			
			</>
			
		)
	}
	
	

	

	// ----------------------------------------
	// Cargar Cotizacion
	// ----------------------------------------
	cargarCotizacions(){
		var codigo = localStorage.getItem('simuladores.proveedores.codigoUsuario' );
		var info = { "codigo": codigo};
		axios.post( misConstantes.URL_CONSULTA + '/ServletModificacionesOrdenesCompra', info, {params: info}).then(function (response) {
			var modificacionesOrdenesCompra = response.data;
			
			var columns = this.state.columnas;
			var rows = [];
			for( var i = 0; i < modificacionesOrdenesCompra.length; i++ ){
				
				const identificador = modificacionesOrdenesCompra[i].idCoupa + "";
				var numeroOrdenCompra  =   modificacionesOrdenesCompra[i].numeroOrdenCompra;
				var fechaModificacion  =   modificacionesOrdenesCompra[i].dfechaModificacion;
				var entidad  =   modificacionesOrdenesCompra[i].entidad.nombre;
				
//				var columnas = [ 
//								
//								{ field: "numeroOrdenCompra", label: "Orden de compra", attributes: {'width':'50%'} },
//								{ field: "fechaModificacion", label: "Fecha", attributes: {'width':'30%'} },
//								{ field:"botones", label: "", sort: 'asc', width :  "20%" , attributes: { 'width': '20%', 'align': 'center' } }
				
				var row = {
							numeroOrdenCompra: numeroOrdenCompra,
							fechaModificacion: fechaModificacion,
							entidad: entidad,
							botones: <div style = {{width: "100%", textAlign: "center" }}>
											<Link to = {'/modificacion-orden-compra/' + identificador }><i class="fas fa-info-circle"></i></Link>&nbsp;
									</div>
						}
				rows.push(row);
			}

			var datos = {columns: columns, rows: rows}
			this.setState({datos: datos});
		}.bind(this)).catch(function (error) {
		});
	}
	
	
}

export default ModificacionesOrdenesCompra;
